import FilterBar from 'components/common/FilterBar';
import React from 'react';
import { FilterContainerStyled } from 'routes/Appointments/components/AppointmentFilterBars/styled';
// import { IMultipleFilterOptionsProps } from 'routes/Users/components/UsersList/types';

const Filter: React.FC = () => {
  const filterBarOptions = [
    { label: 'No Balance', value: false },
    { label: 'With Balance', value: true },
  ];

  return (
    <FilterContainerStyled>
      <FilterBar options={filterBarOptions} notSpecifiedValueLabel='All' name='hasBalance' />
    </FilterContainerStyled>
  );
};

export default React.memo(Filter);
